export default __webpack_public_path__ + "static/media/hht2_ep17_timeline_q03_b.fe7c3c5e.png";